import { rolesTranslations } from '../services/data'
import { rolesColors } from '../services/data'
const filterOpt = ['ideaMaker', 'researcher', 'scripter', 'producer']


export function Filter({ setFilter, filter, roles, isAdmin }) {
    const options = isAdmin ? filterOpt : filterOpt.filter(option => roles.includes(option))
    return <div className="filter">
        {isAdmin && <div onClick={() => setFilter(filter === 'awaiting-feedback' ? '' : 'awaiting-feedback')} className={filter === 'awaiting-feedback' ? 'selected' : ''} >ממתינים לפידבק</div>}
        {isAdmin && <div onClick={() => setFilter(filter === 'admin-jobs' ? '' : 'admin-jobs')} className={filter === 'admin-jobs' ? 'selected' : ''} >משימות שלי</div>}
        {options.map((option, idx) => <div onClick={() => setFilter(filter === option ? '' : option)} className={filter === option ? 'selected' : ''} key={idx}>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', marginLeft: '10px', padding: 0 }} className={rolesColors[option]} />
            {rolesTranslations[option]}
        </div>)}
    </div>
}